import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, switchMap, takeUntil } from 'rxjs/operators'

import { getRangeFromDateFilter } from 'utils/dateUtils'
import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { selectCompanyFilter } from 'containers/PartnerOptions/selectors'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from '../../PartnerOptions/constants'

import { fetchDataError, fetchDataSuccess } from './actions'
import {
  DATA_REQUEST_ASYNC,
  DATE_FILTER_CHANGE,
  GENERAL_FILTER_CHANGE,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SET_DETECTED_BY_FILTER,
  SORTING_CHANGE,
} from './constants'
import {
  selectDateFilter,
  selectDetectedByFilter,
  selectGeneralFilter,
  selectPage,
  selectSearch,
  selectSortingBy,
  selectSortingDirection,
} from './selectors'

const fetchDataEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      DATA_REQUEST_ASYNC.INITIATE,
      SEARCH_CHANGE,
      DATE_FILTER_CHANGE,
      PAGINATE_CHANGE,
      GENERAL_FILTER_CHANGE,
      SET_DETECTED_BY_FILTER,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      SORTING_CHANGE
    ),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.incidents.remediated)
      return true
    }),
    switchMap(() => {
      const state = state$.value
      return api.resolutionCenter
        .getRemediatedIncidents(
          selectPage(state) || 1,
          selectSearch(state),
          selectGeneralFilter(state),
          selectDetectedByFilter(state)?.map((elem) => elem.value),
          getRangeFromDateFilter(selectDateFilter(state)),
          selectCompanyFilter(state)?.value,
          selectSortingBy(state),
          selectSortingDirection(state)
        )
        .pipe(
          map((response) => fetchDataSuccess(response?.response)),
          catchError((error) => of(epicsErrorHandler(fetchDataError, error))),
          takeUntil(action$.pipe(ofType(DATA_REQUEST_ASYNC.CANCEL)))
        )
    })
  )

export default combineEpics(fetchDataEpic)
